import type { Environment } from '@openeducation/oe-rn-services';
import { useMutation } from 'react-query';

export interface SubmitProps {
  env: Environment;
  username: string;
  password: string;
}

export const useAuthentication = <T>({
  authenticateWithUsernameAndPassword,
}: {
  authenticateWithUsernameAndPassword: (
    env: Environment,
    username: string,
    password: string
  ) => Promise<T>;
}) => {
  const { data, error, isError, isLoading, mutateAsync, reset } = useMutation(
    ({ env, username, password }: SubmitProps) =>
      authenticateWithUsernameAndPassword(env, username, password)
  );

  return {
    loginWithUsernameAndPassword: mutateAsync,
    reset,
    isLoading,
    isError,
    data,
    error: error as string,
  };
};

export default useAuthentication;
